"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearPlayAudioListeners = exports.SoundPlayingState = void 0;
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const PLAY_AUDIO_LISTENERS = [];
// eslint-disable-next-line no-shadow
var SoundPlayingState;
(function (SoundPlayingState) {
    SoundPlayingState[SoundPlayingState["PLAYING"] = 0] = "PLAYING";
    SoundPlayingState[SoundPlayingState["PAUSED"] = 1] = "PAUSED";
    SoundPlayingState[SoundPlayingState["NONE"] = 2] = "NONE";
})(SoundPlayingState || (exports.SoundPlayingState = SoundPlayingState = {}));
const clearPlayAudioListeners = (destroy) => {
    while (PLAY_AUDIO_LISTENERS.length >= 1) {
        const clearer = PLAY_AUDIO_LISTENERS.pop();
        if (clearer) {
            clearer();
        }
    }
    destroy();
};
exports.clearPlayAudioListeners = clearPlayAudioListeners;
const buildCallableStartPlayingAudio = (args) => async ({ functionId, entryVars: { uri, }, callbacks, processor, executeProcesses, }) => {
    if (!(0, valueIsString_1.default)(uri) || uri === '') {
        processor.root.alert('Invalid uri to play audio', `${uri}`);
        return;
    }
    const state = await args.getState();
    if (state === SoundPlayingState.PLAYING) {
        return;
    }
    if (state === SoundPlayingState.PAUSED) {
        await args.startPlayingAudio();
        return;
    }
    (0, exports.clearPlayAudioListeners)(args.destroy);
    await args.addRecord(uri);
    let lastTimeUpdate;
    if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.onPlayTimeUpdate) {
        const intervalRef = setInterval(() => {
            args.getCurrentAudioPosition()
                .then((newTimeUpdate) => {
                if (newTimeUpdate !== lastTimeUpdate) {
                    lastTimeUpdate = newTimeUpdate;
                    executeProcesses(functionId, callbacks.onPlayTimeUpdate, lastTimeUpdate);
                }
            });
        }, 500);
        PLAY_AUDIO_LISTENERS.push(() => {
            clearInterval(intervalRef);
        });
    }
    executeProcesses(undefined, callbacks.onStartPlaying);
    PLAY_AUDIO_LISTENERS.push(() => {
        executeProcesses(undefined, callbacks.onStopPlaying);
    });
    await args.startPlayingAudio()
        .catch((error) => {
        executeProcesses(functionId, callbacks.onError, `${error}`);
    });
};
exports.default = buildCallableStartPlayingAudio;
